<template>
  <div class="channel-list p-20">
    <el-tag v-for="(tag, tag_index) in local_data" :key="tag.alias" disable-transitions class="mb-10 mr-10" closable @close="() => handleTagClose({ tag, tag_index })">{{ tag.alias }}</el-tag>
    <el-empty v-if="!local_data.length" :image-size="40" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      local_data: [],
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        this.local_data = val;
      },
    },
  },
  methods: {
    handleTagClose({ tag, tag_index }) {
      this.$emit('remove', { tag, tag_index });
    },
  },
};
</script>
